<div>
  <div class="close-icon" aria-label="Close" (click)="bsModalRef.hide()">
    <mat-icon svgIcon="close" class="close-bootstrap-dialog"></mat-icon>
  </div>
  <div class="fx-col fx-col-h-center fx-col-v-center thank-you-download">
    <b>Thank you!</b>
    <p>Please check your email for the download link.</p>
  </div>
</div>
